import { isValidBIC, isValidIBAN } from "ibantools";
import { isValidPhoneNumber } from "libphonenumber-js";

import { parseNumberWithZero } from "Shared/Utils/Format/number";
import { removeSpaces } from "Shared/Utils/Format/string";

export const isClientEmailValid = (email: string, canBeAgentEmail = false) => {
  if (email) {
    if (!canBeAgentEmail) {
      if (
        email.indexOf("fincentrum.com") !== -1 ||
        email.indexOf("swisslifeselect.sk") !== -1
      ) {
        return false;
      }
    }
    const regex =
      /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }
  return false;
};

export const isPhoneValid = (phone: string): boolean => {
  if (!phone) return false;
  return isValidPhoneNumber(phone);
};

export const isSWIFTValid = (swift: string): boolean => {
  if (!swift) return false;
  return isValidBIC(removeSpaces(swift).toUpperCase());
};

export const isIBANValid = (iban: string) => {
  if (!iban) {
    return false;
  }

  const withoutSpaces = removeSpaces(iban);

  return isValidIBAN(withoutSpaces);
};

export const isCINValid = (cin: string) => {
  if (!cin) {
    return false;
  }

  const regex = /^[0-9]{8}$/;
  return regex.test(cin);
};

export const isCompanyNumberValid = (value: string): boolean => {
  if (!value) return false;
  return /^[A-Za-z0-9]{1,20}$/.test(value);
};

export const isTaxNumberValid = (value: string): boolean => {
  if (!value) return false;
  return /^[A-Za-z0-9]{2,20}$/.test(value);
};

export const isPersonalNumberValid = (identityNumber: string) => {
  let isValid = true;
  if (!identityNumber) return false;

  const value = identityNumber.replace(/\D/g, "");
  if (value.length < 9) isValid = false;

  const yearS = Number.parseInt(value.substring(0, 2), 10);
  const monthS = Number.parseInt(value.substring(2, 4), 10);
  const dayS = Number.parseInt(value.substring(4, 6), 10);

  if ((monthS > 12 && monthS < 50) || monthS > 62) {
    isValid = false;
  }

  if (dayS > 31 || (value.length === 9 && yearS >= 54)) {
    isValid = false;
  }

  const code = parseNumberWithZero(value);

  if (!code) {
    return false;
  }

  if (yearS < 54 && value.length === 9) {
  } else if (code % 11 !== 0 || value.length !== 10) {
    isValid = false;
  }

  return isValid;
};

export const isIdentityCardNumberValid = (identityCardNumber: string) => {
  if (!identityCardNumber) return false;

  return (
    identityCardNumber.length === 9 ||
    identityCardNumber.length === 8 ||
    identityCardNumber.length === 6
  );
};

export const isAdult = (birthDate: string | Date) => {
  if (!birthDate) {
    return false;
  }

  const date = new Date(birthDate);
  const now = new Date();
  const adultDate = new Date(
    now.getFullYear() - 18,
    now.getMonth(),
    now.getDate(),
  );

  return date < adultDate;
};
